import { render } from "./navigation.vue?vue&type=template&id=605c889a&scoped=true"
const script = {}

import "./navigation.vue?vue&type=style&index=0&id=605c889a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605c889a"]])

export default __exports__